var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMir = function SvgMir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F754E",
    fillRule: "evenodd",
    d: "M2.59 10.173c.25-.001.993-.068 1.308.995q.318 1.073 1.013 3.518h.19q.745-2.577 1.024-3.518c.318-1.074 1.114-.995 1.432-.995h2.455v7.637H7.51v-4.5h-.168l-1.395 4.5H4.065L2.67 13.306h-.168v4.504H0v-7.637zm11.015 0v4.504h.2l1.696-3.703c.33-.737 1.031-.8 1.031-.8h2.421v7.636H16.4v-4.504h-.2l-1.663 3.703c-.33.734-1.064.8-1.064.8H11.05v-7.636zm14.177 3.63c-.356 1.009-1.475 1.732-2.714 1.732H22.39v2.275H19.96v-4.008z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#MIR_svg__a)",
    fillRule: "evenodd",
    d: "M25.184 10.174h-5.352c.127 1.7 1.592 3.155 3.107 3.155h5.01c.29-1.413-.705-3.155-2.765-3.155",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "MIR_svg__a",
    x1: 27.999,
    x2: 19.832,
    y1: 12.159,
    y2: 12.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F5CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02AEFF"
  })))));
};
export default SvgMir;